/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import SectionUI from '@msr/Common/SectionUI';
import MsrTopBanner from '@msr/components/HeaderBanner/MsrTopBanner';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 * @param {string} pageData - MahaShivratri PrivacyPolicy Page Data
 */
const VolunteerCoordinatorsLang = ({ pageData, lang }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', 'en');
  }, [authContext]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={''}
        lang={lang}
      />

      <Box
        as="section"
        className="container-article"
      >
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value[0]?.sectionContent?.map((secCon, i) => {
            if (i === 0) {
              return (
                <Box
                  mb="60px"
                >
                  <MsrTopBanner sectionContent={secCon} />
                </Box>
              );
            }
            return (
              <SectionUI
                key={i}
                sectionContent={secCon}
                section={pageData.body[0]?.value[0]}
                region={''}
                language={lang}
              />
            );
            })
          : null}
        
      </Box>
      <PageConfig
        isLikeVisible={false} pageData={pageData}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
      `/mahashivratri/ta/volunteer-coordinators`,
      `/mahashivratri/hi/volunteer-coordinators`
    ]
    : await getLandingPaths('L1', '/volunteer-coordinators');
  return {
    paths: msrPaths,
    fallback: false
  };
};

export const getStaticProps = async ({
  preview, previewData,
  params: { lang }
}) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', lang, 'msr'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('', lang, 'msr'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', lang, 'volunteer-coordinators', {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      lang: lang,
      menuType: 'msrmainmenu'
    },
  };
};

export default VolunteerCoordinatorsLang;
